<template>
  <div class="header-con">
    <div class="big-logo"></div>
    <div class="title-con">
      <div class="title-cn">杭州市第三社会福利院数字驾驶舱</div>
      <div class="title-en">Intelligent elderly care visualization system</div>
    </div>
    <div class="top-line"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.header-con {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 1200px;
  height: 90px;
  .big-logo {
    width: 60px;
    height: 60px;
    pointer-events: auto;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../assets/index/logo.png");
  }
  .title-con {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    margin-left: 10px;
    .title-cn {
      pointer-events: auto;
      display: flex;
      align-items: center;
      background-color: initial;
      border: none;
      border-radius: 0px;
      justify-content: flex-start;
      font-weight: normal;
      font-family: AlibabaPuHuiTi, Arial, "sans-serif";
      font-size: 35px;
      writing-mode: horizontal-tb;
      letter-spacing: 0px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: #ffffff;
    }
    .title-en {
      pointer-events: auto;
      display: flex;
      align-items: center;
      background-color: initial;
      border: none;
      border-radius: 0px;
      justify-content: flex-start;
      font-weight: lighter;
      font-family: AlibabaPuHuiTi, Arial, "sans-serif";
      font-size: 16px;
      writing-mode: horizontal-tb;
      letter-spacing: 6px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: rgba(255, 255, 255, 0.61);
    }
  }
  .top-line {
    width: 641px;
    height: 19px;
    transform: rotate(0deg);
    opacity: 1;
    pointer-events: none;
    left: 751px;
    top: 55px;
    pointer-events: auto;
    image-rendering: -webkit-optimize-contrast;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    -webkit-mask-image: url("https://img.alicdn.com/tfs/TB1zStjhggP7K4jSZFqXXamhVXa-500-24.svg");
    background: rgb(255, 255, 255);
    border-radius: 0px;
    cursor: pointer;
    margin-left: 20px;
  }
}
</style>
